import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import RoleForm from "@components/forms/RoleForm";

const AddEditRole = () => {
  const params = useParams()
  const { roleId } = params

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Administrar de Rol"
      backUrl="/user/acl"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "role",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <RoleForm
        roleId={roleId}
        formId="role"
        saveRedirectUrl="/user/acl"
      />
    </PageContainer>
  );
}

export default AddEditRole;
